import {Record} from 'immutable';

const ErrorMetadata = new Record({
    childId: '',
});

const Warning = new Record({
    error: 0,
    severity: '',
    image: '',
    message: '',
    title: '',
    metadata: null,
});

function fromAPI(data) {
    return new Warning({
        ...data,
        metadata: data.metadata ? new ErrorMetadata(data.metadata) : null,
    });
}

export default {
    record: Warning,
    fromAPI,
};
